import {
  ModuleRegistry,
  AllCommunityModule,
  themeQuartz,
  colorSchemeDark
} from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// HUD tactical skin — tuned to match the EVEORG design tokens in hud.css with
// the readability pass applied (lighter slate/navy surfaces, higher-contrast text).
export const gridTheme = themeQuartz.withPart(colorSchemeDark).withParams({
  accentColor: '#4ec3ee',
  backgroundColor: '#131c28',
  foregroundColor: '#f4f8fc',
  headerBackgroundColor: 'rgba(78, 195, 238, 0.08)',
  headerTextColor: '#d4dde8',
  oddRowBackgroundColor: 'rgba(255,255,255,0.02)',
  rowHoverColor: 'rgba(78, 195, 238, 0.08)',
  selectedRowBackgroundColor: 'rgba(78, 195, 238, 0.18)',
  borderColor: 'rgba(150,195,235,0.10)',
  rowBorderColor: 'rgba(150,195,235,0.10)',
  headerColumnBorder: false,
  fontFamily: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace',
  fontSize: 13,
  headerFontSize: 11
});

export const defaultColDef = {
  sortable: true,
  filter: true,
  floatingFilter: true,
  suppressHeaderMenuButton: true,
  resizable: true
};

// Vertically-center a cell's content (renderer or value).
export const centeredCellStyle = { display: 'flex', alignItems: 'center' };
export const centerAlignedCellStyle = { display: 'flex', alignItems: 'center', justifyContent: 'center' };
export const rightAlignedCellStyle = { display: 'flex', alignItems: 'center', justifyContent: 'flex-end' };
